module.exports = __webpack_public_path__ + "img/20190708165438674.9eb1fc10.png";